<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
name: "baseBar";
import { ref, onMounted,defineProps } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Object,
    default: () => {},
  },
})
// console.log(props.listData);
const myEcharts = ref(null);

onMounted(() => {
  // let data = [
  //   { value: 287.5, name: "2023年全县生产总值" },
  //   { value: 54.57, name: "第一产业增加值" },
  //   { value: 93.51, name: "第二产业增加值" },
  //   { value: 139.44, name: "第三产业增加值" },
  // ];
  initChart(props.listData);
});
const color = ['#3c90ff', '#fff225', '#24ffdf', '#ff9c3c', '#7536ff','#ff0000']
const indicator = [
  {
    text: '水质',
    min: 0,
    max: 100
  },
  {
    text: '土壤成分',
    min: 0,
    max: 100
  },
  {
    text: '土壤状态',
    min: 0,
    max: 100
  },
  {
    text: '病害',
    min: 0,
    max: 100
  },
  {
    text: '虫害',
    min: 0,
    max: 100
  },
  {
    text: '气温',
    min: 0,
    max: 100
  }
]
const Data = [80,86,70,86,77,88]

function setData() {
  return [
    {
      value: Data,
      itemStyle: {
        normal: {
          lineStyle: {
            color: '#4BFFFC',
            shadowColor: '#4BFFFC',
            shadowBlur: 5
          },
          shadowColor: '#4BFFFC',
          shadowBlur: 5
        }
      },
      areaStyle: {
        normal: {
          // 单项区域填充样式
          color: {
            type: 'radial',
            x: 0.5, //右
            y: 0.5, //下
            r: 1,
            colorStops: [
              {
                offset: 1,
                color: '#4BFFFC'
              },
              {
                offset: 0,
                color: 'rgba(0,0,0,0)'
              }
            ],
            globalCoord: false
          },
          opacity: 0.8 // 区域透明度
        }
      }
    }
  ]
}

function setgauge(i) {
  return {
    type: 'gauge',
    detail: false,
    splitNumber: 10, //刻度数量
    radius: '110%', //图表尺寸
    center: ['50%', '50%'],
    startAngle: 90 + 60 * i + 18, //开始刻度的角度
    endAngle: 90 + 60 * (i + 1) - 18, //结束刻度的角度
    axisLine: {
      show: false
    },
    axisTick: {
      show: true,
      lineStyle: {
        color: '#66ccff',
        width: 1
      },
      length: 6,
      splitNumber: 1
    },
    splitLine: {
      show: false
    },
    axisLabel: {
      show: false
    }
  }
}
function setSpot() {
  var scatterData = []
  Data.map((o, i) => {
    scatterData.push({
      value: [o, i],
      itemStyle: {
        normal: {
          color: color[i],
          borderColor: '#fff',
          borderWidth: 1,
          shadowColor: color[i],
          shadowBlur: 8
        }
      }
    })
  })
  return scatterData
}
function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);
  // console.log(listData)

  const option= {
    polar: {
      center: ['50%', '50%'],
      radius: '70%'
    },
    radar: {
      shape: 'circle',
      center: ['50%', '50%'],
      radius: '70%',
      indicator: indicator,
      axisName: {
        color: '#b7e9fd',
        fontSize: 15,
        padding: -10
      },
      nameGap: 26,
      splitNumber: 4,
      splitArea: {
        // 坐标轴在 grid 区域中的分隔区域，默认不显示。
        show: true,
        areaStyle: {
          // 分隔区域的样式设置。
          color: ['rgba(27, 50, 66, 0.4)']
        }
      },
      axisLine: {
        //指向外圈文本的分隔线样式
        lineStyle: {
          color: '#5aa3d0',
          type:'dashed'
        }
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(99,192,251,0.2)', // 分隔线颜色
          width: 2 // 分隔线线宽
        }
      }
    },
    angleAxis: {
      type: 'category',
      data: name,
      minInterval: 1,
      boundaryGap: false,
      clockwise: false,
      axisTick: {
        show: false
      },
      axisLabel: {
        show: false
      },
      axisLine: {
        show: false
      },
      splitLine: {
        show: false
      }
    },
    radiusAxis: {
      min: 0,
      max: 100,
      interval: 25,
      splitLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLine: {
        //指向外圈文本的分隔线样式
        lineStyle: {
          color: '#5aa3d0'
        }
      },
      axisLabel: {
        fontSize: 12,
        color: '#5aa3d0',
        align: 'left',
        margin: -5
      }
    },
    series: [
      setgauge(0),
      setgauge(1),
      setgauge(2),
      setgauge(3),
      setgauge(4),
      setgauge(5),
      {
        type: 'radar',
        silent: true,
        lineStyle: {
          color: '#66ffff'
        },
        areaStyle: {
          color: 'rgba(102, 255, 255, 0.31)'
        },
        data: setData()
      },
      {
        type: 'scatter',
        coordinateSystem: 'polar',
        symbolSize: 10,
        data: setSpot()
      }
    ]
  };// 将你的ECharts配置项放在这里
  chartInstance.setOption(option, true);
}
window.addEventListener("resize", () => {
  chartInstance.resize();
});

</script>
<style lang="less"></style>
